// Copyright (c) 2024. Sendanor <info@sendanor.fi>. All rights reserved.

import { MY_DASHBOARD_MENU_CLASS_NAME } from "../../../../core/constants/className";

import { NavLink, useParams } from "react-router-dom";
import {
    GET_MY_CLIENT_INVENTORY_LIST_ROUTE,
    GET_MY_CLIENT_INVOICE_LIST_ROUTE,
    GET_MY_CLIENT_ROUTE,
    MY_CLIENT_LIST_ROUTE,
} from "../../../../core/constants/route";
import {
    T_MY_DASHBOARD_MENU_CLIENT_LABEL,
    T_MY_DASHBOARD_MENU_CLIENT_LIST_LABEL,
    T_MY_DASHBOARD_MENU_INVENTORY_LIST_LABEL,
    T_MY_DASHBOARD_MENU_INVOICE_LIST_LABEL,
    T_MY_DASHBOARD_MENU_LOGIN_LABEL,
} from "../../../../core/constants/translation";
import "./MyDashboardMenu.scss";
import { TranslationFunction } from "../../../../../../io/hyperify/core/types/TranslationFunction";

export interface MyDashboardMenuProps {
    readonly className ?: string;
    readonly t          : TranslationFunction;
}

export function MyDashboardMenu (props: MyDashboardMenuProps) {
    const className = props?.className;
    const params = useParams();
    const clientId = params?.clientId;
    const t = props?.t;
    if (!clientId) return null;
    return (
        <div className={
            MY_DASHBOARD_MENU_CLASS_NAME
            + (className? ` ${className}` : '')
        }>{clientId ? (
            <>
                <section className={MY_DASHBOARD_MENU_CLASS_NAME+'-section'}>
                    <NavLink end className={MY_DASHBOARD_MENU_CLASS_NAME+"-link"} to={GET_MY_CLIENT_ROUTE(clientId)}>{t(T_MY_DASHBOARD_MENU_CLIENT_LABEL)}</NavLink>
                    {/*<NavLink end className={MY_DASHBOARD_MENU_CLASS_NAME+"-link"} to={GET_MY_CLIENT_ORDER_LIST_ROUTE(clientId)}>{t(T_MY_DASHBOARD_MENU_ORDER_LIST_LABEL)}</NavLink>*/}
                    {/*<NavLink end className={MY_DASHBOARD_MENU_CLASS_NAME+"-link"} to={GET_MY_CLIENT_PAYMENT_LIST_ROUTE(clientId)}>{t(T_MY_DASHBOARD_MENU_PAYMENT_LIST_LABEL)}</NavLink>*/}
                    <NavLink end className={MY_DASHBOARD_MENU_CLASS_NAME+"-link"} to={GET_MY_CLIENT_INVOICE_LIST_ROUTE(clientId)}>{t(T_MY_DASHBOARD_MENU_INVOICE_LIST_LABEL)}</NavLink>
                    <NavLink end className={MY_DASHBOARD_MENU_CLASS_NAME+"-link"} to={GET_MY_CLIENT_INVENTORY_LIST_ROUTE(clientId)}>{t(T_MY_DASHBOARD_MENU_INVENTORY_LIST_LABEL)}</NavLink>
                </section>
                <section className={MY_DASHBOARD_MENU_CLASS_NAME+'-section'}>
                    <NavLink end className={MY_DASHBOARD_MENU_CLASS_NAME+"-link"} to={MY_CLIENT_LIST_ROUTE}>{t(T_MY_DASHBOARD_MENU_CLIENT_LIST_LABEL)}</NavLink>
                </section>
            </>
        ): (
            <>
                <section className={MY_DASHBOARD_MENU_CLASS_NAME+'-section'}>
                    <NavLink end className={MY_DASHBOARD_MENU_CLASS_NAME+"-link"} to={MY_CLIENT_LIST_ROUTE}>{t(T_MY_DASHBOARD_MENU_LOGIN_LABEL)}</NavLink>
                </section>
            </>
        )}</div>
    );
}
